/**
 * Notifica al admin cuando alguien hace click en "Servicios para empresas"
 * @param {string} source - Origen del click: 'advanced-search', 'navbar', 'widget'
 * @param {object} user - Usuario actual (opcional)
 */
export async function notifyPartnerServicesClick(source, user = null) {
  try {
    const payload = {
      source,
      userId: user?.uid || null,
      userEmail: user?.email || null,
      userName: user?.displayName || user?.fullName || null,
      referrer: document.referrer || window.location.href,
    };

    // Fire-and-forget: no esperamos respuesta
    fetch('/api/email/notify-partner-services-click', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      keepalive: true,
    }).catch(() => {
      // Non-blocking: si falla, no afecta la UX
    });
  } catch {
    // Non-blocking
  }
}
